// eslint-disable-next-line no-shadow
export enum InputLengthContract {
    common = 255,
  }